var portfolioPositionsTopFlop = {
	caption: {
		top: "Portfolio positions top results",
		flop: "Portfolio positions flop results",
		gainers: "Portfolio positions gainers",
		losers: "Portfolio positions losers"
	},
	name: "Name",
	isin: "ISIN",
	lastPrice: "Last price",
	lastPriceDateTime: "Date/Time",
	unrealizedPerformance: "Unrealized perf. in {currency}",
	unrealizedPerformanceRelative: "Unrealized perf. %",
	unrealizedPerformanceBar: "Unrealized perf. % of max",
	weight: "Weight %",
	marketValue: "Market value in {currency}",
	actions: "Actions",
	noPositions: "No results found"
};
var en = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { en as default, portfolioPositionsTopFlop };
